/**
 * X 로 닫은 회차 기억 — 키 하나에 roundId 를 저장한다(회차마다 키가 쌓이지 않게).
 * 저장소가 막힌 웹뷰(SecurityError)에서도 던지지 않는다: 읽기 실패는 "닫지 않음", 쓰기 실패는 무시.
 */
const DISMISSED_ROUND_KEY = 'winner_toast_dismissed_round'
/** 예전 방식(2026-06~09): 회차마다 `winner_toast_dismissed_{roundId}` = 'true' */
const LEGACY_KEY_PATTERN = /^winner_toast_dismissed_(\d{4}-\d{2}-jackpot)$/

/** 옛 키를 새 키로 이어받고 지운다. 이미 닫은 9월 토스트가 배포 후 다시 뜨지 않게 */
function migrateLegacyKeys(current: string | null): string | null {
  const legacyRounds: string[] = []
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    const match = key?.match(LEGACY_KEY_PATTERN)
    if (!key || !match) continue
    if (localStorage.getItem(key) === 'true') legacyRounds.push(match[1])
    localStorage.removeItem(key)
  }
  if (current || legacyRounds.length === 0) return current

  const latest = legacyRounds.sort().at(-1) as string
  localStorage.setItem(DISMISSED_ROUND_KEY, latest)
  return latest
}

export function readDismissedRound(): string | null {
  try {
    return migrateLegacyKeys(localStorage.getItem(DISMISSED_ROUND_KEY))
  } catch {
    return null
  }
}

export function writeDismissedRound(roundId: string): void {
  try {
    localStorage.setItem(DISMISSED_ROUND_KEY, roundId)
  } catch {
    // 저장 실패 — 이번 로드에서만 닫힌다
  }
}
